import { render, staticRenderFns } from "./KioskSplashScreen.vue?vue&type=template&id=f9f98ea6&scoped=true"
import script from "./KioskSplashScreen.vue?vue&type=script&lang=js"
export * from "./KioskSplashScreen.vue?vue&type=script&lang=js"
import style0 from "./KioskSplashScreen.vue?vue&type=style&index=0&id=f9f98ea6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f98ea6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9f98ea6')) {
      api.createRecord('f9f98ea6', component.options)
    } else {
      api.reload('f9f98ea6', component.options)
    }
    module.hot.accept("./KioskSplashScreen.vue?vue&type=template&id=f9f98ea6&scoped=true", function () {
      api.rerender('f9f98ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/kiosk/KioskSplashScreen.vue"
export default component.exports